<template>
  <button
    type="button"
    class="excel-btn"
    :disabled="isLoading"
    @click="makeSheetExcel"
  >
    <b-spinner
      v-if="isLoading"
      small
      class="mr-50"
      label="Loading"
    />
    <feather-icon
      v-else
      icon="DownloadCloudIcon"
      size="16"
      class="mr-50"
    />

    <span>{{ isLoading ? 'Exporting...' : 'Excel' }}</span>
  </button>
</template>
<script>

import axios from 'axios'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default {
  props: {
    skipPage: {
      type: Number,
      default: () => 0,
    },
  },
  data() {
    return {
      isLoading: false,
    }
  },

  methods: {

    async makeSheetExcel() {
      try {
        if (this.isLoading) return
        this.isLoading = true
        // const searchExcel = this.$route.query.search || ''
        // https://gulftic-system.fci.group/api/admin/payroll/:id?userId=&skip&take&search&officeId&export=true
        const response = await axios.get('/user/excel-sheet', {
          responseType: 'blob',
        })

        if (response.status === 200) {
          const now = new Date()
          const formattedDate = now.toISOString().split('T')[0]
          const formattedTime = now.toTimeString().split(' ')[0].replace(/:/g, '-')
          const dateTimeString = `users ${formattedDate}_${formattedTime}`

          const blob = new Blob([response.data], { type: response.data.type })
          const url = window.URL.createObjectURL(blob)

          const link = document.createElement('a')
          link.href = url
          link.download = dateTimeString
          link.click()

          this.$toasted.show('Updated Successfully', {
            position: 'top-center',
            duration: 3000,
          })
        }
      } catch (error) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: `${error}`,
            icon: 'BellIcon',
            variant: 'danger',
          },
        })
      } finally {
        this.isLoading = false
      }
    },

  },
}
</script>

<style scoped>
.excel-btn {
  appearance: none;
  border: 1px solid rgba(34, 41, 47, 0.12);
  background: rgba(255, 255, 255, 0.95);
  color: rgba(34, 41, 47, 0.8);
  border-radius: 12px;
  height: 42px;
  padding: 0 14px;
  display: inline-flex;
  align-items: center;
  font-weight: 900;
  letter-spacing: -0.1px;
  white-space: nowrap;
  transition: transform 120ms ease, box-shadow 120ms ease, border-color 120ms ease;
}

.excel-btn:hover:not(:disabled) {
  border-color: rgba(115, 103, 240, 0.25);
  box-shadow: 0 10px 22px rgba(115, 103, 240, 0.14);
  transform: translateY(-1px);
}

.excel-btn:active:not(:disabled) {
  transform: translateY(0);
  box-shadow: 0 6px 14px rgba(115, 103, 240, 0.12);
}

.excel-btn:disabled {
  opacity: 0.7;
  cursor: not-allowed;
}
</style>
